/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconSlider8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSlider8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 .667C1.262.667.665 1.264.665 2v1.334c0 .736.597 1.333 1.333 1.333h4c.737 0 1.334-.597 1.334-1.333V2c0-.736-.597-1.333-1.334-1.333H2ZM1.332 2c0-.368.298-.666.666-.666h4c.369 0 .667.298.667.666v1.334A.667.667 0 0 1 5.999 4H2a.667.667 0 0 1-.666-.666V2ZM1.666 5.167a1 1 0 0 0-1 1v.167a1 1 0 0 0 1 1h4.667a1 1 0 0 0 1-1v-.167a1 1 0 0 0-1-1H1.666Zm-.333 1c0-.184.149-.333.333-.333h1v.833h-1a.333.333 0 0 1-.333-.333v-.167Zm3.333-.333H3.333v.833h1.333v-.833Zm.667 0h1c.184 0 .333.149.333.333v.167c0 .184-.15.333-.333.333h-1v-.833Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSlider12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSlider12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3ZM2 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3ZM2.5 7.75A1.5 1.5 0 0 0 1 9.25v.25A1.5 1.5 0 0 0 2.5 11h7A1.5 1.5 0 0 0 11 9.5v-.25a1.5 1.5 0 0 0-1.5-1.5h-7ZM2 9.25a.5.5 0 0 1 .5-.5H4V10H2.5a.5.5 0 0 1-.5-.5v-.25Zm5-.5H5V10h2V8.75Zm1 0h1.5a.5.5 0 0 1 .5.5v.25a.5.5 0 0 1-.5.5H8V8.75Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSlider16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSlider16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 1.333A2.667 2.667 0 0 0 1.335 4v2.666a2.667 2.667 0 0 0 2.667 2.667h8a2.667 2.667 0 0 0 2.666-2.667V4a2.667 2.667 0 0 0-2.666-2.667H4ZM2.668 4c0-.737.597-1.334 1.334-1.334h8c.736 0 1.333.597 1.333 1.334v2.666c0 .737-.597 1.334-1.333 1.334H4a1.333 1.333 0 0 1-1.334-1.334V4ZM3.334 10.333a2 2 0 0 0-2 2v.333a2 2 0 0 0 2 2h9.333a2 2 0 0 0 2-2v-.333a2 2 0 0 0-2-2H3.334Zm-.667 2c0-.368.299-.667.667-.667h2v1.667h-2a.667.667 0 0 1-.667-.667v-.333Zm6.667-.667H6.667v1.667h2.667v-1.667Zm1.333 0h2c.369 0 .667.299.667.667v.333a.667.667 0 0 1-.667.667h-2v-1.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSlider24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSlider24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6ZM4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6ZM5 15.5a3 3 0 0 0-3 3v.5a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-.5a3 3 0 0 0-3-3H5Zm-1 3a1 1 0 0 1 1-1h3V20H5a1 1 0 0 1-1-1v-.5Zm10-1h-4V20h4v-2.5Zm2 0h3a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-3v-2.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconSlider = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSlider(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconSlider8 {...iconProps} />;
        case '12':
            return <IconSlider12 {...iconProps} />;
        case '16':
            return <IconSlider16 {...iconProps} />;
        case '24':
            return <IconSlider24 {...iconProps} />;
        default:
            return <IconSlider24 {...iconProps} />;
    }
});
